"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formUtil_1 = require("../formUtil");
const ConditionOperator_1 = __importDefault(require("./ConditionOperator"));
class IsEmptyValue extends ConditionOperator_1.default {
    static get operatorKey() {
        return 'isEmpty';
    }
    static get displayedName() {
        return 'Is Empty';
    }
    static get requireValue() {
        return false;
    }
    execute({ value, conditionComponentPath, data, conditionComponent }) {
        return (0, formUtil_1.isComponentDataEmpty)(conditionComponent, data, conditionComponentPath, value);
    }
    getResult(options) {
        return this.execute(options);
    }
}
exports.default = IsEmptyValue;
